module.exports = __webpack_public_path__ + "img/logov2.16294eb1.png";